<template>
	<b-button
		size="lg"
		variant="secondary"
		class="themes-button d-flex justify-content-center align-items-center"
		@click="$emit('click')"
	>
		<span>
			{{ text }}
		</span>
		<span v-if="themesLength" class="themes-button__length ml-2">
			{{ themesLength }}
		</span>
		<div v-if="!themesLength" class="themes-button__plus ml-2">
			<span class="icon icon-plus" />
		</div>
	</b-button>
</template>
<script>

export default {
	name: 'ThemesButton',
	props: {
		themes: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		themesLength() {
			return this.themes?.length;
		},
		text() {
			return this.themesLength ? 'Выбрано тем' : 'Выбрать темы';
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

.themes-button {
	// height: 4rem;
	// padding: 0 2rem;
	// font-size: 1.2rem;
	// border-radius: 2.5rem;
	background-color: $white;
	color: black;

	&:hover {
		span {
			// color: $white;
		}

		.themes-button {
			&__plus {
				background-color: $white;
				color: $primary !important;
			}

			&__length {
				color: $white;
			}
		}
	}

	span {
		white-space: nowrap;
	}

	&__plus {
		width: 2rem;
		height: 2rem;

		display: flex;
		align-items: center;
		justify-content: center;
		background-color: $primary;
		color: $white;
		border-radius: 50%;
		@include transition($btn-transition);

		.icon {
			font-size: 1rem;
			line-height: 1rem;
		}

		@include media-breakpoint-down(md) {
			width: 1.5rem;
			height: 1.5rem;

			.icon {
				font-size: 0.6rem;
				line-height: 0.6rem;
			}
		}
	}

	&__length {
		color: $primary;
	}
}
</style>
